var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 30"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "more_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  d: "M0 0h6.001v20.002H0z",
  "data-name": "Rectangle 6852"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18560"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h25v30H0z",
  "data-name": "Rectangle 55"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#more_svg__a)",
  "data-name": "Group 18465",
  transform: "translate(9.5 4.999)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M3 12a2 2 0 1 0-2-2 2 2 0 0 0 2 2Zm0-7a2 2 0 1 0-2-2 2 2 0 0 0 2 2Zm0 14a2 2 0 1 0-2-2 2 2 0 0 0 2 2Z",
  "data-name": "Path 27063"
})))));
export { SvgMore as ReactComponent };
export default __webpack_public_path__ + "static/media/more.f4339b74b432fe47dd6885530e17d863.svg";